import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  CircularProgress,
  Container,
  Grid,
  makeStyles,
  Modal,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import firebase from "firebase";
import { TextField } from "formik-material-ui";
import { Field, Form, Formik } from "formik";
import { isNull, isUndefined } from "underscore";
import MyTextArea from "./MyTextArea";

function EditIzlagaci() {
  let db = firebase.database();
  const [data, setData] = useState([]);
  const [currentIzlagac, setCurrentIzlagac] = useState(null);

  const [modal, setModal] = useState(false);

  useEffect(() => {
    if (data.length === 0) {
      firebase
        .database()
        .ref("EditPage/izlagaci")
        .once("value")
        .then((promise) => {
          setData(promise.val());
        });
    }
  }, [currentIzlagac, data]);

  const useStyles = makeStyles({
    root: {
      maxWidth: 345,
    },
    media: {
      height: 200,
    },
  });

  const classes = useStyles();

  function handleModlaOpen(indx) {
    if (indx === undefined) {
      firebase
        .database()
        .ref("/EditPage/izlagaci_counter")
        .once("value")
        .then((res) => {
          setCurrentIzlagac(res.val());
          setModal(true);
        });
    } else {
      setCurrentIzlagac(indx);
      setModal(true);
    }
  }
  function handleDelete(indx) {
    firebase
      .database()
      .ref("/EditPage/izlagaci/" + indx)
      .remove();
    window.location.reload(false);
  }

  function closeModal() {
    setModal(false);
  }

  function PresenterForm(props) {
    const { ID, presenter } = props;

    const [img, setImg] = useState(null);

    const [imgUrl, setImgUrl] = useState(isUndefined(presenter)?null:presenter.slika);
    const [uploadProgress, setUploadProgress] = useState(0);



    
    function handleSubmit(values) {
      const  storageRef = firebase.storage().ref();

      if (!isNull(img)) {
        let uploadTask = storageRef
          .child("Slike/Izlagaci/" + ID + "/" + img.name)
          .put(img);
        uploadTask.on(
          firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          function (snapshot) {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            setUploadProgress(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
          },
          function (errors) {},
          function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                let newState = values;
                newState.slika = downloadURL;
                firebase
                  .database()
                  .ref("/EditPage/izlagaci/" + "/" + ID)
                  .set(newState)
                  .then(()=>{
                    firebase
                    .database()
                    .ref("/EditPage/izlagaci_counter")
                    .once("value")
                    .then((res) => {
                      if (ID === res.val()) {
                        const novo = ID + 1;
                        firebase
                          .database()
                          .ref("/EditPage/izlagaci_counter")
                          .set(novo)
                          .then((res) => {
                            window.location.reload(false);
                          });
                      } else {
                        window.location.reload(false);
                      }
                    });
                  });
                
              });
          }
        );
      } else {
        firebase
          .database()
          .ref("/EditPage/izlagaci/" + "/" + ID)
          .set(values);
      

      //Counter ++
      firebase
        .database()
        .ref("/EditPage/izlagaci_counter")
        .once("value")
        .then((res) => {
          if (ID === res.val()) {
            const novo = ID + 1;
            firebase
              .database()
              .ref("/EditPage/izlagaci_counter")
              .set(novo)
              .then((res) => {
                window.location.reload(false);
              });
          } else {
            window.location.reload(false);
          }
        });
      }
    }

    return (
      <React.Fragment>
        <Formik
          initialValues={
            !isUndefined(presenter)
              ? presenter
              : {
                  ime: "",
                  prezime: "",
                  opis: "",
                  slika: "",
                }
          }
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          <Form>
            <Grid
              style={{
                backgroundColor: "white",
                padding: "20px",
                border: "5px solid lightblue",
                margin: "10px",
                width:"100%"
              }}
              container
              direction="column"
            >
              <Grid item style={{width:"100%"}}>
                <Field
                  component={TextField}
                  label="Ime"
                  required
                  name="ime"
                  type="text"
                  style={{width:"100%"}}
                  
                />
              </Grid>
              <Grid item >
                <Field
                  component={TextField}
                  label="Prezime"
                  required
                  name="prezime"
                  type="text"
                  style={{width:"100%"}}
                  
                />
              </Grid>
              <Grid item >
                <MyTextArea
                 name="opis"
                 label="Opis (maksimalno 100 charactera)" 
                 rows={8}
                 style={{
                  marginTop:"10px",
                width:"100%"}}
                 required
                />
                {/* <Field 
                  component={TextField}
                  label="Opis (maksimalno 100 charactera)" 
                  required
                  name="opis"
                  min="100" 
                  style={{
                    marginTop:"10px",
                  width:"100%"}}
                /> */}
              </Grid>
              <Grid item>
                <img src={imgUrl} style={{height:"10%"}}/>
                {isUndefined(presenter)?
                
                <Field
               
                  label="Promjeni Sliku"
                  name="new_img"
                  type="file"
                  accept="image/*"
                  required
                  onChange={(e) => {
                    setImgUrl(URL.createObjectURL(e.target.files[0]));
                    setImg(e.target.files[0]);
                  }}
                />
            
                  :
                  <Field
                  label="Promjeni Sliku"
                  name="new_img"
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    setImgUrl(URL.createObjectURL(e.target.files[0]));
                    setImg(e.target.files[0]);
                  }}
                />}


              </Grid>

              <Grid item>
                <Button type="submit" variant="contained" color="primary" style={{backgroundColor:"#45B283 "}}>Spremi promjene</Button>
                {uploadProgress!==0?<div>{uploadProgress} %
                  <CircularProgress/>
                </div>:null}
              </Grid>
            </Grid>
          </Form>
        </Formik>
      </React.Fragment>
    );
  }

  return (
    <Container style={{ margin: "50px auto", textAlign: "center" }}>
      <Typography variant="h3">Uređivanje izlagača</Typography>
      <Typography variant="h5">
        Dodajte ili izbrišite i uredite izlagače
      </Typography>
      {Object.keys(data).length >= 8 ? null : (
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleModlaOpen()}
        >
          Dodaj novog izlagača
        </Button>
      )}
      <Typography>
        {data == null ? (
          <CircularProgress />
        ) : (
          Object.keys(data).map((el) => {
            return (
              <React.Fragment>
                <Card
                  style={{
                    border: "3px solid lightblue",
                    width: "50%",
                    margin: "0 auto",
                    marginBottom: "20px",
                    marginTop: "20px",
                  }}
                >
                  <CardActionArea>
                    <CardMedia
                      className={classes.media}
                      image={data[el].slika}
                      title="Contemplative Reptile"
                    />
                  </CardActionArea>
                  <CardHeader title={data[el].ime + " " + data[el].prezime} />
                  <CardContent>
                    <Typography
                      paragraph
                      variant="body2"
                      color="textSecondary"
                      component="p"
                    >
                      {data[el].opis}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleModlaOpen(el)}
                    >
                      Uredi Izlagača
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => handleDelete(el)}
                    >
                      Izbriši Izlagača
                    </Button>
                  </CardActions>
                </Card>
              </React.Fragment>
            );
          })
        )}
        {/* MODAL Start */}
        <React.Fragment>
          <Modal
            open={modal}
            onClose={closeModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{overflow:"scroll",margin:"20px auto",width:"50%"}}
          >
            <PresenterForm
              ID={currentIzlagac}
              presenter={data[currentIzlagac]}
            ></PresenterForm>
          </Modal>
        </React.Fragment>
        {/* MODAL END */}
      </Typography>
    </Container>
  );
}

export default EditIzlagaci;
